import {
  BROKER_CHECK_FAILED_REASON,
  BROKER_INACTIVE_ACTION_REASON,
} from '@/features/brokers/utils/broker-status.util';
import type { Installment } from '@/services';

/**
 * Extrato de Parcelas lista várias corretoras: o status vem por linha
 * (`brokerActive`). O boleto só fica liberado com a corretora confirmada como
 * ativa (`true`); `false` (inativa) e `null`/ausente (sem CNPJ ou status
 * indisponível) travam.
 */
export function isRowBoletoBlocked(
  row: Pick<Installment, 'brokerActive'>
): boolean {
  return row.brokerActive !== true;
}

/** Motivo exibido no `title` do "Baixar boleto" travado. */
export function rowBoletoBlockedReason(
  row: Pick<Installment, 'brokerActive'>
): string | undefined {
  if (row.brokerActive === true) return undefined;
  return row.brokerActive === false
    ? BROKER_INACTIVE_ACTION_REASON
    : BROKER_CHECK_FAILED_REASON;
}
